import React, { useContext, useState } from 'react';
import { CommonContext } from '../../../../App';
import { RenderBottomImage, RenderMainFilters, RenderSubfilters, RenderNoVisit, RenderPresentedDates } from '../common/common';
import AppointmentHelper from '../../../../helpers/appointment-helper';
import WidgetSizeHelper from '../../../../helpers/widget-size-helper';
import SubResult from '../../../../models/subresult';
import DateHelper from '../../../../helpers/date-helper';
import ScrollbarHelper from '../../../../helpers/scrollbar-helper';
import Appointment from '../../../../models/appointment';
import noVisitsSrc from '../../../../images/no-visits-logo.png';
import avatarFemale from '../../../../images/avatar_female.svg';
import avatarMale from '../../../../images/avatar_male.svg';
import config from '../../widget-config';
import mediClubLogo from '../../../../images/mediclub-logo.png';
import scrollDown from '../../../../images/scroll-down.svg';

export const MegawidgetSComponent: React.FC = () => {
  const [filterResults, setFilterResults] = useState(false);
  const { state, dispatch } = useContext(CommonContext);

  if (state.isLoading) {
    return <div className="s-container isLoading"></div>
  }
  else {
    return (
      <div className="s-container">
        <div className="s-topbar">
          <div className="s-topLogo"></div>
          <div className={state.bookVisit ? "s-topElement active" : "s-topElement"} onClick={() => dispatch({ type: "SET_BOOK_VISIT", payload: { bookVisit: true } })}>Umów wizytę</div>
          {/* <div className={state.bookVisit ? "s-topElement" : "s-topElement active"} onClick={() => dispatch({ type: "SET_BOOK_VISIT", payload: { bookVisit: false } })}>Umów badanie</div> */}
        </div>
        {/* <div className="s-switchBar">
          <div className={state.serviceInOffice ? "" : "bolded"}>Teleporada</div>
          <label className="switch">
            <input type="checkbox" defaultChecked={state.serviceInOffice} onChange={() => dispatch({ type: "SET_SERVICE_IN_OFFICE", payload: { serviceInOffice: !state.serviceInOffice } })} />
            <span className="slider round"></span>
          </label>
          <div className={state.serviceInOffice ? "bolded" : ""}>W gabinecie</div>
        </div> */}
        <div className="s-selectsDiv">
          {RenderMainFilters("s", 294, 294, 294, 19, 19, 19, state.selectedRegionDescription, state.selectedSpecialisationDescription)}
        </div>
        {state.result.subResults.length > 0 ?
          <>
            <div className="s-datesDiv">{RenderPresentedDates("s", WidgetSizeHelper.S.presentedDates)}</div>
            {/* {RenderFilters("s-showFiltersButton", state.widgetSize, filterResults, setFilterResults)} */}
            <div className="s-resultsDiv">{RenderResultSSize()}</div>
          </>
          :
          RenderNoVisit("s")
        }
        {RenderBottomImage("s")}
      </div>
    )
  }
}

const RenderResultSSize = () => {
  const { state, dispatch } = useContext(CommonContext);

  return (
    <>
      {ScrollbarHelper.isVisible(state, 2) &&
          <img className="s-resultScrollbar" src={scrollDown} alt="" />}
      {
        state.result.subResults.map((sub: SubResult) => {
          if (sub.appointmentsDate.getTime() === state.selectedDate.getTime()) {
            if (sub.appointmentsCounter > 0) {
              return sub.appointments.map((app: Appointment, index: number) => {
                const appDate = new Date(app.dateTime);
                return (
                  <div className="row s-singleResult" key={index}>
                    <div className="col-3 s-singleResultLeft">
                      <img alt="photo" src={index % 2 === 0 ? avatarFemale : avatarMale} className="s-avatarImg" />
                      <div className="s-singleResultHour">{DateHelper.getTimeInHHMMFormat(appDate)}</div>
                      <div className="s-singleResultDate">{DateHelper.getDateShort(appDate)}</div>
                    </div>
                    <div className="col-9 s-singleResultRight">
                      <div>
                        <div className="s-singleResultDoctorType">{app.doctor.description ? app.doctor.description : "Brak danych"}</div>
                        <div style={{ fontSize: "14px", marginTop: "10px", color: "#444" }}>{app.specialty.description ? app.specialty.description : "Brak danych"}</div>
                        <div style={{ fontSize: "14px", marginTop: "10px", color: "#444" }}>{app.clinic.description ? `${app.clinic.description}, ${app.clinic.street}` : "Brak danych"}</div>
                      </div>
                      <div>
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-7" style={{ paddingRight: "0" }}>
                            <div style={{ display: "grid", gridTemplateColumns: "auto auto" }}>
                              <div></div>
                              <div className="s-singleResultServicePrice">{app.price}.00 zł.</div>
                              <div><img src={mediClubLogo} style={{ width: "50px", marginBottom: "9px" }} /></div>
                              <div className="s-singleResultMedistoreClubPrice">100.00 zł.</div>
                            </div>
                          </div>
                          <div className="col-5">
                            <a target="_blank" href={`${config.CART_URL}?visit=true&doctor_code=${app.doctor.code}&re_location=${app.region.code}&location_id=${app.locationId}&product_id=${app.productId}&date=${app.dateTime}`} className="s-singleResultBuyServiceButton">Kup wizytę</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              });
            }
            else {
              return (
                <div className="s-noVisitsContainer">
                  <img src={noVisitsSrc} />
                  <span className="s-noVisitsText">Brak dostępnych wizyt</span>
                </div>
              )
            }
          }
        })
      }
      {state.result.subResults.find((sub: SubResult) => sub.appointmentsCounter >= state.maxAppointmentsToShow && sub.appointmentsDate.getTime() === state.selectedDate.getTime()) &&
          <a className="s-showAllResultsButton" target="_blank" href={`https://www.medicover.pl/lekarze/${state.selectedSpecialisationDescription}/${state.selectedRegionDescription},sl,s`}>Zobacz wszystkie</a> }
    </>
  )
}

const RenderFilters = (buttonClass: string, size: string, filterResults: boolean, setFilterResults: React.Dispatch<React.SetStateAction<boolean>>): React.ReactElement => {
  if (filterResults == false) {
    return (
      <button className={buttonClass} onClick={() => setFilterResults(true)}>Filtruj wyniki</button>
    )
  }
  else {
    return (
      <>
        <button className={buttonClass} onClick={() => setFilterResults(false)}>Ukryj filtry</button>
        <div className={`${size}-selectsDiv`}>{RenderSubfilters(size, 294, 34, 294, 100, 294, 168)}</div>
      </>
    )
  }
}